import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { relationshipRecommAPI } from '../services/api';
import AppHeader from './AppHeader';
import RelationshipRecomm from './RelationshipRecomm';
import './IntelligenceCentre.css';

const isDev = process.env.NODE_ENV === 'development';

function IntelligenceCentre() {
  const { t } = useTranslation();
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [regenerating, setRegenerating] = useState(false);

  const fetchRecommendations = async () => {
    try {
      const res = await relationshipRecommAPI.getAll();
      setRecommendations(res.data);
    } catch (err) {
      console.error('Failed to fetch recommendations:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecommendations();
  }, []);

  const handleApply = async (id) => {
    try {
      await relationshipRecommAPI.apply(id);
      fetchRecommendations();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to apply recommendation');
    }
  };

  const handleDismiss = async (id) => {
    try {
      await relationshipRecommAPI.dismiss(id);
      setRecommendations(recommendations.filter(r => r.id !== id));
    } catch (err) {
      alert('Failed to dismiss recommendation');
    }
  };

  const handleRegenerate = async () => {
    setRegenerating(true);
    try {
      await relationshipRecommAPI.regenerate();
      await fetchRecommendations();
    } catch (err) {
      alert('Failed to regenerate recommendations');
    } finally {
      setRegenerating(false);
    }
  };

  return (
    <div className="intelligence-centre">
      <AppHeader />

      <div className="intelligence-content">
        <h1>{t('intelligence.title')}</h1>

        {loading ? (
          <div className="loading">{t('common.loading')}</div>
        ) : (
          <>
            <section className="intelligence-section">
              <div className="section-header">
                <h2>{t('intelligence.relationshipSuggestions')} ({recommendations.length})</h2>
                {isDev && (
                  <button
                    onClick={handleRegenerate}
                    className="btn btn-small btn-refresh"
                    disabled={regenerating}
                  >
                    {regenerating ? t('intelligence.refreshing') : t('intelligence.refresh')}
                  </button>
                )}
              </div>
              {recommendations.length === 0 ? (
                <p className="empty-message">{t('intelligence.noSuggestions')}</p>
              ) : (
                <div className="recommendations-list">
                  {recommendations.map(recomm => (
                    <RelationshipRecomm
                      key={recomm.id}
                      recommendation={recomm}
                      onApply={handleApply}
                      onDismiss={handleDismiss}
                      showLinks={true}
                    />
                  ))}
                </div>
              )}
            </section>

            <section className="intelligence-section coming-soon">
              <h2>{t('intelligence.photoTags')}</h2>
              <p className="empty-message">{t('intelligence.comingSoon')}</p>
            </section>

            <section className="intelligence-section coming-soon">
              <h2>{t('intelligence.eventSuggestions')}</h2>
              <p className="empty-message">{t('intelligence.comingSoon')}</p>
            </section>
          </>
        )}
      </div>
    </div>
  );
}

export default IntelligenceCentre;
